// extracted by css-extract-rspack-plugin
export default {"ShortcutsDialogRoot":"KeyboardShortcutsDialog-module__ShortcutsDialogRoot__Rplxi","LoadingStateContainer":"KeyboardShortcutsDialog-module__LoadingStateContainer__ZKxJs"};